import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { is, path as rPath } from 'ramda';

import exists from 'lib/exists';

const pickValues = (formValues, path) => (path ? rPath(path, formValues) : formValues);

class ConditionalSection extends Component {
  componentDidMount() {
    const { condition, onComponentRenders, path } = this.props;
    const { formValues } = this.context;
    const values = pickValues(formValues, path);
    is(Function, onComponentRenders) && onComponentRenders(condition(values));
  }

  componentWillUpdate(nextProps, nextState, { formValues: nextValues }) {
    const { condition, path } = this.props;
    const { formValues } = this.context;
    const values = pickValues(formValues, path);

    return exists(condition) && exists(values) && exists(nextValues) && condition(values) !== condition(nextValues);
  }

  render() {
    const { children, condition, hideInEdit, hideInView, path } = this.props;
    const { formValues, editing } = this.context;
    const values = pickValues(formValues, path);

    return !((editing && hideInEdit) || (!editing && hideInView)) && exists(condition) && condition(values) ? (
      <div children={children} />
    ) : null;
  }
}

ConditionalSection.propTypes = {
  condition: PropTypes.func.isRequired,
  onComponentRenders: PropTypes.func,
  hideInEdit: PropTypes.bool,
  hideInView: PropTypes.bool,
  path: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

ConditionalSection.contextTypes = {
  formValues: PropTypes.object,
  editing: PropTypes.bool,
};

export default ConditionalSection;
